/**
 *
 * @author Matthew Rawson @ 13/09/2018 11:46
 * @description
 * @notes
 */
import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import id from "@irati/utils/id/index"
import {StatusPillBadge} from "../StatusPillBadge"


class StatusCellRenderer extends PureComponent {
  static propTypes = {
    row: PropTypes.object,
    accessor: PropTypes.string
  }
  static defaultProps = {
    row: {},
    accessor: "data.from"
  }


  constructor(props) {
    super(props)
    this.state = {}
  }


  render() {
    const idNamespace = id("StatusCellRenderer", this.props)
    const {row, accessor} = this.props

    return <StatusPillBadge
      id={idNamespace}
      validationStatus={get(row, accessor)}
      contentKey="insights.reports.status" />
  }
}

export default StatusCellRenderer
